import type { ApiConfig, ApiLocation, Config, TenantId } from '@/hooks/config';

export function loadFirebaseConfig() {
  if (import.meta.env.VITE_FIREBASE_CONFIG) {
    const config = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG);

    return config;
  }

  return {};
}

export function loadTenantConfig() {
  let tenant: TenantId;
  if (import.meta.env.VITE_TENANT_ID) {
    tenant = import.meta.env.VITE_TENANT_ID as TenantId;
  } else if (import.meta.env.VITE_APP_ENV === 'dev') {
    tenant = 'dev';
  } else {
    tenant = 'vivechurch';
  }

  return tenant;
}

export function loadApiConfig(): ApiConfig {
  const tenant = loadTenantConfig();
  const location = (import.meta.env.VITE_API_LOCATION ||
    'cloud') as ApiLocation;

  return {
    tenant,
    location,
    baseUrl: new URL('/api/admin/', window.location.href).toString(),
  };
}

export function loadDebugConfig() {
  if (!import.meta.env.DEV) {
    return false;
  }

  if (import.meta.env.VITE_DEBUG === 'false') {
    return false;
  }

  return true;
}

export function loadConfig(): Config {
  const api = loadApiConfig();
  const debug = loadDebugConfig();

  return {
    api,
    debug,
  };
}
